import { render, staticRenderFns } from "./DownloadIphone.vue?vue&type=template&id=7937152a&scoped=true"
import script from "./DownloadIphone.vue?vue&type=script&lang=js"
export * from "./DownloadIphone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7937152a",
  null
  
)

export default component.exports